import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {SAVE_TRANSACTION_SUCCESS, SAVE_TRANSACTION_ERROR} from "../../constants";
import {getUserData, reduxSetPayerUser} from "../../Actions/authActions";
import {amountFormatterWithZero} from "../../utils";

const GooglePayNmi = ({
    subdomain,
    adminUser,
    user,
    totalAmount,
    patientPayerInfo,
    showResult,
    setPaymentInfo
}) => {
    const dispatch = useDispatch();
    const [scriptLoaded, setScriptLoaded] = useState(false);

    const getNewPatientPayer = () => {
        const balancesPaid = [];
        patientPayerInfo.forEach((i) => {
            if (i) {
                balancesPaid.push({
                    patientFirst: i.patientFirst,
                    patientLast: i.patientLast,
                    patientNumber: i.patientNumber,
                    patientPayerId: i.patientPayerId,
                    amountPaid: i.accountBalance < 0 ? 0 : i.accountBalance,
                });
            }
        });
        return balancesPaid;
    };

    useEffect(() => {
        if (window.CollectJS && adminUser?.paymentGateways) {
            initializeGooglePay();
        }
    }, [window.CollectJS, adminUser, totalAmount]);

    const initializeGooglePay = () => {
        try {
            const googlePayForm = document.getElementById("googlepaymyForm");
            if (googlePayForm) {
                googlePayForm.style.display = 'block';
            }

            window.CollectJS.configure({
                variant: 'inline',
                tokenizationKey: adminUser.paymentGateways.tokenizationKey,
                fields: {
                    googlePay: {
                        buttonType: 'pay',
                        selector: '.google-pay-button',
                        "billingAddressRequired": true,
                        "billingAddressParameters": {
                            "phoneNumberRequired": true,
                            "format": "MIN"
                        },
                        'emailRequired': true,
                    },
                },
                price: totalAmount.toString(),
                currency: 'USD',
                country: 'US',
                callback: handleGooglePayCallback,
            });

            setScriptLoaded(true);
        } catch (error) {
            console.error("Error initializing Google Pay:", error);
        }
    };

    const handleGooglePayCallback = async (response) => {
        try {
            if (response && response.response === '1') {
                // Extract wallet information from the response
                const wallet = response.frontEndGatewayResponse?.wallet || {};
                const billingInfo = wallet.billingInfo || {};

                localStorage.setItem('PENDING_TRANSACTION', JSON.stringify({
                    payerEmail: user.payerEmail,
                    patientPayer: getNewPatientPayer(),
                    total: amountFormatterWithZero(totalAmount),
                    transactionId: response?.transactionid,
                }));

                const updatedPatientPayers = user.patientPayer.map(ptPayer => {
                    const matchingPatientPayer = patientPayerInfo.find(ppInfo =>
                        ppInfo && ppInfo.patientPayerId === ptPayer.patientPayerId
                    );
                    if (matchingPatientPayer) {
                        const unpaidBalance = parseFloat(ptPayer.accountBalance) - parseFloat(matchingPatientPayer.accountBalance);
                        return {
                            ...ptPayer,
                            accountBalance: unpaidBalance,
                        };
                    }
                    return ptPayer;
                });

                const updatedUser = {
                    ...user,
                    patientPayer: updatedPatientPayers,
                };

                localStorage.setItem("state", JSON.stringify({patientPayerInfo: updatedPatientPayers}));
                dispatch(reduxSetPayerUser(updatedUser));
                showResult("approval");
                dispatch({type: SAVE_TRANSACTION_SUCCESS});

                setTimeout(() => {
                    dispatch(getUserData(subdomain));
                    setPaymentInfo({
                        name: "", cardnumber: "", expiry: "", cvv: "",
                    });
                }, 1000);
            } else {
                showResult("error", response);
                dispatch({type: SAVE_TRANSACTION_ERROR});
            }
        } catch (error) {
            console.error("Error processing Google Pay payment:", error);
            showResult("error", error);
            dispatch({type: SAVE_TRANSACTION_ERROR});
        }
    };

    return (
        <div>
            <iframe
                name="googlepaydummyframe"
                id="googlepaydummyframe"
                style={{display: "none"}}
            />
            <form
                action="#"
                method="post"
                name="googlepaymyForm"
                id="googlepaymyForm"
                target="googlepaydummyframe"
                style={{display: "none"}}
            >
                <div className="google-pay-button"/>
            </form>
        </div>
    );
};

export default GooglePayNmi;
